import React from 'react';
import classNames from 'classnames';
import css from './css.module.less';

const ContentGrid = (props) => {
  const { configCols, mainCol, hasTranslationTip } = props;
  return (
    <div className={css.wrapper}>
      {mainCol && <div className={css.mainCol}>{mainCol}</div>}

      <div
        className={classNames(css.row, {
          [css.withTranslationTip]: hasTranslationTip,
        })}>
        {(configCols || []).map((i, index) => {
          const { child } = i;
          return (
            <div className={css.col} key={i.key || index}>
              {child}
              {/* <div
                  style={{ background: 'red', width: '100%', height: 900 }}
                /> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ContentGrid;
